/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RovoAiProjectEntryPointProps } from './RovoAiProjectEntryPoint.entrypoint.types.tsx';

type RovoAiProjectEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	RovoAiProjectEntryPointProps,
	{} | null
>;

export const rovoAiProjectEntryPoint: EntryPoint<RovoAiProjectEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<RovoAiProjectEntryPointComponent>(
			/* webpackChunkName: "async-chat-only-creation-modal" */ './RovoAiProjectEntryPointWrapper.tsx',
		),
		getPreloadProps: () => ({}),
	});
